export default __webpack_public_path__ + "static/media/c2.b4c5cd0e.jpeg";